/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Tarjeta_Mision_Vision_Informacion from "./Tarjetas/Tarjeta_Mision_Vision_Informacion";
import mision from "../../../Recursos/mision.png";
import vision from "../../../Recursos/vision.png";


const Mision_Vision_Informacion = () => {

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}>

            <Grid2 container
                   spacing={18}
                   size={12}
                   sx={{maxWidth: '1400px', px: 3}} justifyContent={'center'}>

                <Grid2 container size={{xs: 12, sm: 12, md: 11}}>

                    {items.map((item, index) => (
                        <Grid2 container size={12}>
                            <Tarjeta_Mision_Vision_Informacion
                                titulo={item.titulo}
                                imagen={item.imagen}
                                parrafo={item.parrafo}
                            />
                        </Grid2>

                    ))}

                </Grid2>

            </Grid2>


        </Grid2>
    )

}
export default Mision_Vision_Informacion;

const items = [
    {
        imagen: mision,
        titulo: 'Misión',
        parrafo: 'NUESTRA MISIÓN SONAR S.A.S. Es una institución privada con sentido social que presta servicios de salud y seguridad en el trabajo, apoyando al sector empresarial privado y público buscando el bienestar y buena calidad de vida de los trabajadores, a través de servicios personalizados en: medicina y seguridad en el trabajo, investigación de accidentes e incidentes de trabajo, capacitación, asesoría y asistencia técnica en proyectos de seguridad y salud en el trabajo, con el fin de cumplir con las necesidades de nuestros clientes, adelantados por personal idóneo y suficiente, cumpliendo con la normatividad vigente, apoyados en equipos y tecnología de alta calidad.'
    },
    {
        imagen: vision,
        titulo: 'Visión',
        parrafo: 'En el 2036 SONAR S.A.S. será una empresa especializada líder en el departamento de Nariño en salud y seguridad en el trabajo que busca la excelencia en la prestación de servicios integrales de salud y seguridad en el trabajo propendiendo por el bienestar de los trabajadores, la competitividad, rendimiento y productividad de las empresas Nariñenses.'
    }
]